import { Box } from "@mui/material";
import styled from "styled-components";
import laptopImg from "../../../assets/images/Welcome_1440px.png";
import tabletImg from "../../../assets/images/Welcome_700px.png";
import mobileImg from "../../../assets/images/Welcome_550px.png";

export const RescheduleContainerStyled = styled(Box)`
  height: 100vh;
  background-image: url(${laptopImg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 1024px) {
    /* Tablet view */
    background-image: url(${tabletImg});
  }

  @media (max-width: 768px) {
    /* Mobile view */
    background-image: url(${mobileImg});
  }
  .main-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    .reschedule-container-wrapper {
      max-width: 600px;
      width: 100%;
      padding: 20px;
      margin: 0 auto;
      @media (max-width: 1024px) {
        padding: 20px;
      }

      @media (max-width: 768px) {
        padding: 16px;
      }
    }
  }
  .card-wrapper{
    border-radius: 10px;
  }
`;

export const TimeChangeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const ButtonFooter = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
`;